import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RunningWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  '&>h4': {
    fontSize: '40px',
    fontWeight: 'bold',
    // fontFamily: 'Monaco',
  },
  '&>h5': {
    fontWeight: 700,
    color: '#F44336',
    fontSize: '12px',
    fontFamily: 'Monaco',
    transform: 'translateY(10px)',
  },
  [theme.breakpoints.down('md')]: {
    '&>h4': {
      fontSize: '24px',
      transform: 'translateY(-18px)',
    },
    '&>h5': {
      transform: 'translateY(-8px)',
    },
  },
}));

export const PrepareWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  mb: theme.spacing(4),
  '&>h4': {
    fontSize: '54px',
    color: '#fff',
    fontWeight: 'bold',
  },
  '&>h5': {
    color: theme.palette.primary.main,
    fontSize: '16px',
  },
  [theme.breakpoints.down('md')]: {
    '&>h4': {
      fontSize: '28px',
      transform: 'translateY(-18px)',
    },
    '&>h5': {
      transform: 'translateY(-8px)',
    },
  },
}));

export const EndWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  marginBottom: theme.spacing(4),
  '&>h4': {
    fontSize: '20px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    // fontFamily: 'Monaco',
  },
  '&>h5': {
    fontSize: '20px',
    transform: 'translateY(10px)',
  },
  [theme.breakpoints.down('md')]: {
    '&>h4': {
      fontSize: '18px',
      // transform: 'translateY(-18px)',
    },
    '&>h5': {
      fontSize: '16px',
      // transform: 'translateY(-8px)',
    },
  },
}));

export const WinRateWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    // display: 'flex',
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
  },
}));
